import { useEffect } from 'react'
import classNames from 'classnames'

import { EMPTY_STRING } from '../../../constants/common'
import { useContentOverflow } from '../../../hooks'
import {
  BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER,
  BUTTON_HEIGHT_24,
  ButtonArrow,
} from '../../Button'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'

import * as styles from './SubMenuAccordionButton.module.css'

function SubMenuAccordionButton({
  accordionTitle,
  index,
  initOpen,
  open,
  qaName = EMPTY_STRING,
  onClick,
  onOpen,
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  useEffect(() => {
    if (initOpen) {
      onOpen(index)
    }
  }, [])

  const buttonClassName = classNames(styles.SubMenuAccordionButton, {
    [styles.withSelectedItem]: !open && initOpen,
  })

  return (
    <ButtonArrow
      showTextTooltip
      className={buttonClassName}
      getTooltip={null}
      height={BUTTON_HEIGHT_24}
      iconPlacement={BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER}
      isOpen={open}
      qaName={qaName}
      onClick={onClick}
    >
      <FloatingTooltip content={accordionTitle} disabled={!overflow}>
        <Text className={styles.text} ref={setContentOverflowRef}>
          {accordionTitle}
        </Text>
      </FloatingTooltip>
    </ButtonArrow>
  )
}

export default SubMenuAccordionButton
